export default {
  name: 'Terms',
  data() {
    return {
      termsAgreed: false,
    };
  },
  methods: {
    onAgree(agree) {
      this.$emit('agree', agree);
    },
  },
};
